import { render, staticRenderFns } from "./Frontend.vue?vue&type=template&id=1978808c&scoped=true"
import script from "./Frontend.vue?vue&type=script&lang=js"
export * from "./Frontend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1978808c",
  null
  
)

export default component.exports